import { Box, Button, Grid, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function UrineTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Albumin" size="small" variant="outlined" name="albumin" {...register('albumin')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Sugar" size="small" variant="outlined" name="sugar" {...register('sugar')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Reaction" size="small" variant="outlined" name="reaction" {...register('reaction')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
